<template>
  <div class="threejsContainer">
    <div class="containerTitle">1-12.字体改变</div>
    <div ref="container" class="containerBody"></div>
  </div>
</template>

<script>
import * as THREE from 'three';
import {generateScene} from '@/threejsEnv/scene.js';
import {OrbitControls} from 'three/examples/jsm/controls/OrbitControls.js';
import {FontLoader}    from 'three/examples/jsm/loaders/FontLoader.js';
import {TextGeometry}  from 'three/examples/jsm/geometries/TextGeometry.js';
import {generateShader} from './components/shader';

export default {
  data() {
    return {
      scene: null,
      camera: null,
      renderer: null,
      controls: null,
      currentMesh: null,
      fullPath: null,
      circleShape: null,
      progress: 0,
      u_time: 0,
      animationId: null
    };
  },
  mounted() {
    //初始化环境
    this.initEnv();
    //创建粒子系统
    this.createParticleSystem();
    // 监听窗口大小变化
    window.addEventListener('resize', this.onWindowResize);
  },
  methods: {
    createParticleSystem() {
      const fontLoader = new FontLoader();
      fontLoader.load("fonts/gentilis_bold.typeface.json",(font)=>{
        const textGeometry = new TextGeometry('Hello SNBC !', {
          font: font,
          size: 2,               // H的平面大小（XY轴）
          height: 0.3,           // 关键：Z轴厚度（值越大，立体效果越明显）
          curveSegments: 3,      // 增加平面顶点密度（确保H轮廓平滑）
          bevelEnabled: true,    // 可选：保留斜角（增加立体细节）
          bevelThickness: 2.0,
          bevelSize: 0.05,
          bevelSegments: 1
        });
      
        //-------------------------这段可以不加--start------------------------------
        
        const shader = generateShader();
        // 4. 创建点对象并添加到场景
        this.particleSystem = new THREE.Mesh(textGeometry, shader);
        // Z轴压缩到1%（仅影响厚度）
        this.particleSystem.scale.set(1, 1, 0.01); 
        this.particleSystem.position.x = -8.0; 

        this.scene.add(this.particleSystem);
        //-------------------------这段可以不加--end------------------------------


        const edgesGeometry = new THREE.EdgesGeometry(textGeometry);
        const dashedMaterial = new THREE.LineDashedMaterial({
            color: 0xff0000,
            linewidth: 1,
            dashSize: 0.1, // 破折号的长度
            gapSize: 0.05 // 破折号之间的间隙长度
        });
        const cubeEdges = new THREE.LineSegments(edgesGeometry, dashedMaterial);
        //关键步骤，只有这一步虚线才能展示出来
        cubeEdges.computeLineDistances(); 
        cubeEdges.scale.set(1, 1, 0.01); 
        cubeEdges.position.x = 6.0; 
        cubeEdges.position.z = -10.0; 
        cubeEdges.rotation.y = -1.0; 
        this.scene.add(cubeEdges);

        this.animate();
      },
      (xhr) => {
        this.progress = (xhr.loaded / xhr.total);
      });
    },
    animate() {
      this.animationId = requestAnimationFrame(this.animate);
      this.u_time+=0.05;
      this.particleSystem.material.uniforms.u_time.value = this.u_time;
      this.controls.update();
      this.renderer.render(this.scene, this.camera);
    },
    initEnv(){
      // 初始化场景
      this.scene = generateScene();
      this.scene.background = new THREE.Color(0xffffff);

      // 初始化相机
      this.camera = new THREE.PerspectiveCamera(
        75,
        this.$refs.container.clientWidth / this.$refs.container.clientHeight,
        0.1,
        1000
      );
      this.camera.position.set(0, 5, 10);

      // 初始化渲染器
      this.renderer = new THREE.WebGLRenderer({ antialias: true });
      this.renderer.setSize(
        this.$refs.container.clientWidth,
        this.$refs.container.clientHeight
      );
      this.$refs.container.appendChild(this.renderer.domElement);

      // 添加轨道控制器
      this.controls = new OrbitControls(this.camera, this.renderer.domElement);
      this.controls.enableDamping = true;

      // 创建光源
      const ambientLight = new THREE.AmbientLight(0xffffff, 0.5);
      this.scene.add(ambientLight);
      
      const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
      directionalLight.position.set(10, 20, 15);
      this.scene.add(directionalLight);

      const gridHelper = new THREE.GridHelper(100, 100,
                                              0x666666,   // 中心轴线颜色（红色）
                                              0xcccccc    // 普通网格线颜色（绿色）
                                              ); // 10x10 网格
      this.scene.add(gridHelper);
    },
    onWindowResize() {
      const width = this.$refs.container.clientWidth;
      const height = this.$refs.container.clientHeight;

      // 更新相机
      this.camera.aspect = width / height;
      this.camera.updateProjectionMatrix();

      // 更新渲染器
      this.renderer.setSize(width, height);
    }
  },
  beforeDestroy() {
    // 清理动画和事件监听
    cancelAnimationFrame(this.animationId);
    window.removeEventListener('resize', this.onWindowResize);
    
    // 释放资源
    if (this.currentMesh) {
      this.scene.remove(this.currentMesh);
      this.currentMesh.geometry.dispose();
      this.currentMesh.material.dispose();
    }
    
    this.controls.dispose();
    this.renderer.dispose();
    this.renderer.domElement.remove();
  }
};
</script>

<style>
</style>
